export default "__VITE_ASSET__CnNE64U8__"